<template lang="pug">
v-app    
  app-login(v-if="IsValidate==false" @login="val=> {IsValidate=true,menuOption.item=val.item, menuOption.subitem=val.subitem }")
  #App(v-else v-bind:class='this.menuOption.config')    
      transition(name="fade" mode="out-in") 
        app-header( :infoUsuario='menuOption', 
                    @accion='menuClose()', 
                    @logout="loginout()")
      transition(name="fade" mode="out-in") 
        app-menu(:menuSubItem='menuOption.subitem', 
                :menuItem='menuOption.item', 
                @compactMenu='menuCompact()', 
                @closeMenu='menuClose()',
                @closeMenuMobile='menuCloseMobile()')   
      transition(name="fade" mode="out-in")  
        .ContentContainer       
          .Content(style="position : relative; padding:20px")  
            modal_loading(tipo="1", v-show="IsLoading")
            transition(name="fade" mode="out-in")           
              router-view
</template>

 <script>
import header from "./components/header.vue";
import menu from "./components/menu.vue"; 
import { EventBus } from "../../complementos/event-bus.js";
import modal_loading from "../../complementos/modal_loading.vue"; 
import login from "./components/login.vue";

export default {
  // Datos
  data() {
    return {
      loginShow: true,
      IsLoading: false,
      IsValidate:false,
      menuOption: { 
        item:[],
        subitem:[],
        config: "App -header-fixed -header-fixed-mobile -sidebar-compact-tablet -sidebar-open-tablet",
        page: "/",
        user: "Juan"
      }
    };
  }, 
  created(){
    EventBus.$on("loading", (valor = false) => {
      this.IsLoading = valor;
    });
    
  },
  mounted(){
    console.log('Menu Items:', this.menuOption.item);
    console.log("string para separar")
    console.log('Menu Subitems:', this.menuOption.subitem);
  },
  // Metodos
  methods: { 
    loginout(){
      this.loginShow = true; 
      this.IsValidate = false;
      this.$info={}     
      console.log("cerramnos")
      this.$cookies.remove("cookieSLC");
    },
    menuCloseMobile(){
      if (window.innerWidth < 768 || screen.width < 768) {
        var nameCss = "-sidebar-open-mobile";
        if (this.menuOption.config.indexOf(nameCss) > 0) {
          this.menuOption.config = this.menuOption.config.replace(nameCss, "");
        } else {
          this.menuOption.config = this.menuOption.config + " " + nameCss;
        }
      }
    },
    menuClose(){
      if (window.innerWidth < 768 || screen.width < 768) {
        var nameCss = "-sidebar-open-mobile";
        if (this.menuOption.config.indexOf(nameCss) > 0) {
          this.menuOption.config = this.menuOption.config.replace(nameCss, "");
        } else {
          this.menuOption.config = this.menuOption.config + " " + nameCss;
        }
      } else {
        var nameCss = "-sidebar-closed-desktop";
        if (this.menuOption.config.indexOf(nameCss) > 0) {
          this.menuOption.config = this.menuOption.config.replace(nameCss, "");
        } else {
          this.menuOption.config = this.menuOption.config + " " + nameCss;
        }
      }
    },
    menuCompact(){
      var nameCss = "-sidebar-compact-desktop";
      if (this.menuOption.config.indexOf(nameCss) > 0) {
        this.menuOption.config = this.menuOption.config.replace(nameCss, "");
      } else {
        this.menuOption.config = this.menuOption.config + " " + nameCss;
      }
    }
  },

  // Components
  components:{ 
    "app-header": header,
    "app-menu": menu,
    "app-login": login,
    modal_loading
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
